import { Box } from '@mui/material'

type Props = Readonly<{
  checked?: boolean
}>

export const RadioIcon = ({ checked }: Props) => {
  return (
    <Box
      component="span"
      sx={{
        position: 'relative',
        width: 16,
        height: 16,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        border: '1px solid',
        borderColor: 'text.secondary',
        bgcolor: 'common.white',
        borderRadius: '50%',
        boxShadow: 'inset 0px 1px 4px rgba(0, 0, 0, 0.04)',

        ...(checked && {
          '&::after': {
            content: '""',
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            width: 8,
            height: 8,
            borderRadius: '50%',
            border: '1px solid',
            borderColor: 'primary.light',
            backgroundColor: 'primary.main',
          },
        }),
      }}
    />
  )
}
